import { render, staticRenderFns } from "./ItemBrowser.vue?vue&type=template&id=da822fd6&scoped=true"
import script from "./ItemBrowser.vue?vue&type=script&lang=js"
export * from "./ItemBrowser.vue?vue&type=script&lang=js"
import style0 from "./ItemBrowser.vue?vue&type=style&index=0&id=da822fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da822fd6",
  null
  
)

export default component.exports